import { render, staticRenderFns } from "./modifypassword.vue?vue&type=template&id=0f267ed0&scoped=true&"
import script from "./modifypassword.vue?vue&type=script&lang=js&"
export * from "./modifypassword.vue?vue&type=script&lang=js&"
import style0 from "./modifypassword.vue?vue&type=style&index=0&id=0f267ed0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f267ed0",
  null
  
)

export default component.exports